import React from 'react';
import { TooltipIcon } from '../Tooltip';
import { Alert, Link, Text } from '../core';

export const Sector = (): JSX.Element | null => {
  return (
    <Alert
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 1,
      }}
    >
      <Link
        sx={{ alignText: 'right', textDecoration: 'none' }}
        href="https://app.sector.finance"
      >
        <Text mt={1} sx={{ color: 'offwhite' }}>
          <TooltipIcon /> Scion Finance is now Sector Finance. Scion vaults will
          soon be deprecated. Please move funds to{' '}
          <Text sx={{ textDecoration: 'underline' }}>app.sector.finance</Text>.
        </Text>
      </Link>
    </Alert>
  );
};
